export default "__VITE_ASSET__DIRXAqkM__"